










import Vue from 'vue'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'Logout',
  async created() {
    this.$_resetStoreState()
    this.logout()

    // アプリなら端末内の情報を上書き削除
    if (this.$_hasCordova) {
      await this.$_secureSaveAccount({
        userId: '',
        password: ''
      })
    }
  },
  methods: {
    ...mapActions('Auth', ['logout'])
  }
})
